import {
  documentMeta,
  preamble,
  articles,
  annexes,
} from "@/data/legalContent";

export const ui = {
  legalDocuments: "Legal Documents",
  customerAgreement: "Customer Agreement",
  contents: "Contents",
  backToTop: "Back to top",
  acceptLabel:
    "I confirm that I have read, understood and accept the Terms & Conditions and the Personal Data Processing Information Notice.",
  acceptError: "Please tick the box to accept before continuing.",
  acceptButton: "Accept & Continue",
  successTitle: "Policy accepted",
  successBody:
    "Thank you. You have confirmed that you have read, understood and accepted the LoJack Terms & Conditions and the Personal Data Processing Information Notice.",
  acceptedOn: "Accepted on",
  closingNotice: "This page will close automatically in {n} seconds…",
  closedFallback: "You can now close this window.",
  langName: "English",
};

export const content = {
  documentMeta,
  preamble,
  articles,
  annexes,
  ui,
};
